import React from 'react';
import { TweenLite, CSSPlugin, Draggable } from "gsap/all";
import ThrowPropsPlugin from "../vendors/ThrowPropsPlugin";
import LazyImage from "./LazyImage";
import Slider from "react-slick";

import "../assets/css/vendors/slick.css";
// import "../assets/css/vendors/slick-theme.css";

class ProjectAssetsSlider extends React.Component {
    constructor(props) {
        super(props);

        this.slider = React.createRef();
        this.wrapper = React.createRef();
        this.container = React.createRef();
        this.rootEl = React.createRef();

        this.settings = {
            dots: false,
            arrows: false,
            speed: 450,
            // slidesToShow: 1,
            // slidesToScroll: 1,
            cssEase: 'ease-out',
            infinite: true
        };

        this.activeSlide = 0;
        this.creditsShown = false;
        this.slideWidth = window.innerWidth;
        this.assets = this.props.assets.filter((asset) => asset.displayInMobileSlider);
        this.slidesCount = this.assets.length;
        this.sliderWidth = `${100 * this.slidesCount}%`;

        // this.snapX = this.snapX.bind(this);
        // this.refresh = this.refresh.bind(this);
        this.toggleCredits = this.toggleCredits.bind(this);
    }

    componentDidMount() {
        // window.addEventListener('scroll', this.closeCredits);
        // window.addEventListener('resize', this.refresh);
        // window.addEventListener('load', this.refresh);

        // this.container.current.addEventListener('click', this.toggleCredits);

        // this.initialize();
    }

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.closeCredits);
        // window.removeEventListener('resize', this.refresh);
        // window.removeEventListener('load', this.refresh);
        
        // this.container.current.removeEventListener('click', this.toggleCredits);
    }

    initialize() {
        // Draggable.create(this.slider.current, {
        //     type: 'x',
        //     // dragResistance: 0,
        //     // edgeResistance: 1,
        //     // throwResistance: 1,
        //     bounds: this.container.current,
        //     minDuration: 0.75,
        //     throwProps: true,
        //     snap: this.snapX
        //     // onClick: this.toggleCredits
        // });

        

        // this.refresh();
    }

    // updatePosition() {
    //     TweenLite.set(this.slider.current, {
    //         x: this.activeSlide * this.slideWidth
    //     });
    // }

    refresh() {
        this.resize();
        // this.updatePosition();
    }

    toggleCredits(e) {
        if(!this.creditsShown) {
            this.openCredits();
        }
        else {
            this.closeCredits();
        }
    }

    openCredits() {
        if(!this.creditsShown) {
            this.rootEl.current.classList.add('credits-shown');
            this.creditsShown = true;
            this.props.onClickFn(this.props.index);
        }
    }

    closeCredits() {
        if(this.creditsShown) {
            this.rootEl.current.classList.remove('credits-shown');
            this.creditsShown = false;
        }
    }

    resize() {
        this.slideWidth = window.innerWidth;
    }

    snapX(value) {
        let snapValue = Math.round(value / this.slideWidth) * this.slideWidth;
        this.activeSlide = snapValue / this.slideWidth;
      
        return snapValue;
    }

    render() {
        return (
            <div ref={this.rootEl} className="project" style={{position: 'relative'}}>
                <div ref={this.wrapper} className="project-assets-slider">
                    <div ref={this.container} className="overflow">
                        {/*<div ref={this.slider} className="slider-container" style={{width: this.sliderWidth}}>*/}
                        <Slider {...this.settings}>
                            {this.assets.map((asset, index) => {
                                // if(index === 0) return '';

                                let ref = React.createRef();
                                let params = {
                                    src: asset.small[0].src,
                                    srcSet: `${asset.small[1].src} ${asset.small[1].width}w, ${asset.small[0].src} ${asset.small[0].width}w`,
                                    sizes: '100%',
                                    alt: '',
                                    width: asset.small[1].width,
                                    height: asset.small[1].height
                                };

                                // return <LazyImage key={`asset_${index}`} ref={ref} attrs={params} />
                                // return <img key={`asset_${index}`} src={params.src} srcSet={params.srcSet} sizes={params.sizes} alt={params.alt} />;
                                return <img key={`asset_${index}`} onClick={this.toggleCredits} src={params.src} srcSet={params.srcSet} sizes={params.sizes} alt={params.alt} />;
                            })}

                        </Slider>
                        {/*</div>*/}
                        <div className="credits">
                            <ul className="no-style container">
                                {this.props.details.left.concat(this.props.details.right).map((detail, index) => { 
                                    return <li key={`details_left_${index}`}><span className="red barlow-me">{detail.title}</span> {detail.label}</li>;
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectAssetsSlider;


// WEBPACK FOOTER //
// ./src/components/ProjectAssetsSlider.js